import React, { useState } from 'react';

import KeywordItem from './KeywordItem';

import {
    TextField, ToggleButton, ToggleButtonGroup,
    Box, Alert, Stack,
    IconButton
} from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineSharpIcon from '@mui/icons-material/CheckCircleOutlineSharp';

// agregar keyword
const ProductKeywords = ({ keywords, setProdValues }) => {
    const [toggle, setToggle] = useState('list');
    const [keyword, setKeyword] = useState(''); // input

    const handleChange = ({ target }) => {
        setKeyword(target.value);
    };

    // agregar nueva keyword
    const onClick = () => {
        if (keyword.trim().length > 2) {
            setKeyword('');
            setProdValues(e => ({
                ...e,
                keywords: [...e.keywords, keyword]
            }));
            setToggle('list');
        }
    };

    // keywords / añadir keyword
    const onToggle = (event, pos) => {
        if (pos !== null)
            setToggle(pos);
    };

    return (
        <>
            {/* <Grid container>
                <Grid item xs={8}>
                    <Divider>
                        <Chip label="Keywords" sx={{ fontSize: 16 }} />
                    </Divider>
                </Grid>
                <Grid item xs={4}> */}
            {/* <Box>
                        <ToggleButtonGroup
                            value={ toggle }
                            exclusive
                            onChange={ onToggle }
                            aria-label="toggle keywords"
                            size="small">
                            <ToggleButton value="list" aria-label="keyword list">
                                <ListIcon />
                            </ToggleButton>
                            <ToggleButton value="add" aria-label="add keyword">
                                <AddIcon />
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box> */}
            {/* </Grid>
            </Grid> */}
            <ToggleButtonGroup sx={{ mb: 2, mt: .5 }}
                value={toggle}
                exclusive
                onChange={onToggle}
                aria-label="toggle keywords"
                size="small">
                <ToggleButton value="list" aria-label="keyword list">
                    <ListIcon />
                </ToggleButton>
                <ToggleButton value="add" aria-label="add keyword">
                    <AddIcon />
                </ToggleButton>
            </ToggleButtonGroup>
            {
                toggle === 'add' ? (
                    <Stack direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}>
                        <TextField
                            fullWidth
                            name="keyword"
                            placeholder="Añadir keyword"
                            variant="outlined"
                            value={keyword}
                            onChange={handleChange}
                            sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, }}
                        />
                        <IconButton onClick={onClick}>
                            <CheckCircleOutlineSharpIcon color='primary' />
                        </IconButton>
                    </Stack>
                ) :
                    <>
                        {
                            keywords.length <= 0 ?
                                <Alert severity="info">
                                    Añada keywords
                                </Alert>
                                :
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', gap: 1.5, alignItems: 'center' }}>
                                    {
                                        keywords.map((e, i) =>
                                            <KeywordItem
                                                key={i}
                                                keyword={e}
                                                setProdValues={setProdValues}
                                            />
                                        )
                                    }
                                </Box>

                        }
                    </>
            }
        </>
    );
};

export default ProductKeywords;
